<template>
    <v-card flat class="ma-0 pa-0">
        <v-card-title>
            Prochains concerts
        </v-card-title>
        <v-list three-line>
            <v-list-item-group v-model="selected">
                <jazz-concert
                    v-for="concert in concerts"
                    :key="concert.id"
                    :concert="concert" />
            </v-list-item-group>
        </v-list>
    </v-card>
</template>

<script>
import JazzConcert from './JazzConcert'

export default {
    name: 'jazz-concerts',
    components: { JazzConcert },
    data: () => ({
        selected: null
    }),
    computed: {
        concerts() {
            return this.$store.getters.concerts
        }
    },
    mounted() {
        this.$store.dispatch('concerts')
    }
}
</script>
